import Dialog from '../../../common/Dialog'
import { Button } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../../i18n'
import Actions from '../../../../actions'

const TimeSlotExpireDialog = () => {
  const dispatch = useDispatch()
  const isSlotExpireDialogVisible = useSelector(
    state => state.payment.isSlotExpireDialogVisible
  )
  const onClose = () => {
    dispatch(Actions.createAction(Actions.DISBALE_SLOT_EXPIRE_DIALOG))
  }
  return (
    <>
      <Dialog
        title={$t('pages.getStarted.slotExpired.title')}
        isVisible={isSlotExpireDialogVisible}
        footerActions={
          <Button
            key="1"
            className="dialog-action"
            type="primary"
            onClick={onClose}
          >
            {$t('common.ok')}
          </Button>
        }
        onCancel={onClose}
        className="declare-location-dialog"
      >
        <div className="dialog-content">
          <div className="subtitle">
            {$t('pages.getStarted.slotExpired.message')}
          </div>
        </div>
      </Dialog>
    </>
  )
}
export default TimeSlotExpireDialog
